import * as Yup from 'yup';

const addRefferalSchema = Yup.object().shape({
    name: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Nama Lengkap harus diisi')
        .max(60, 'Nama tidak boleh lebih dari 60 karakter.')
        .matches(/^[A-Za-z ]*$/, 'Nama hanya boleh berisi huruf dan spasi'),
    ktpNumber: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Nomor KTP harus diisi')
        .length(16, 'Nomor KTP harus memiliki 16 digit.')
        .matches(/^[0-9]*$/, 'Nomor KTP harus memiliki 16 digit.'),
    birthDate: Yup.string()
        .required('Tanggal Lahir harus diisi')
        .matches(
            /^\d{4}[-](0[1-9]|1[012])[-](0[1-9]|[12][0-9]|3[01])$/,
            'Tanggal Lahir harus dalam format "YYYY-MM-DD"'
        ),
    gender: Yup.string()
        .required('Jenis Kelamin harus diisi'),
    country: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Negara Tinggal harus diisi'),
    negaraLahir: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Negara Lahir harus diisi'),
    nationality: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .required('Kewarganegaraan harus diisi'),
    phoneNumber: Yup.string()
        .required('Nomor Telepon harus diisi')
        .min(11, 'Nomor Telepon minimal 9 digit.')
        .matches(
            /^62\d{8,16}$/,
            'Invalid format. cth: 628129238923. Maksimal 16 digit'
        ),
    email: Yup.string()
        .email('Masukkan alamat email yang valid.')
        .required('Alamat Email harus diisi')
        .max(234, 'Email tidak boleh lebih dari 234 karakter.'),
    bankName: Yup.string()
        .typeError('Nama Bank harus diisi')
        .required('Nama Bank harus diisi'),
    accountNumber: Yup.string()
        .required('Nomor Rekening harus diisi')
        .matches(/^[0-9]*$/, 'Nomor Rekening harus berupa angka')
        .min(10, 'Nomor Rekening minimal 10 digit')
        .max(16, 'Nomor Rekening maksimal 16 digit'),
    accountName: Yup.string()
        .trim('Tidak dapat mengisi hanya dengan spasi')
        .matches(/^[A-Za-z ]*$/, 'Nama Pemilik hanya boleh berisi huruf dan spasi')
        .required('Nama Pemilik Rekening harus diisi')
        .max(60, 'Nama tidak boleh lebih dari 60 karakter.'),
    npwpStatus: Yup.string()
        .required('Pilihan NPWP harus diisi'),
    npwpNumber: Yup.string()
        .when('npwpStatus', {
            is: '01',
            then: Yup.string().required('Nomor NPWP harus diisi jika Anda memilih Ya pada pilihan NPWP.')
                .matches(/^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/, 'Nomor NPWP tidak valid'),
            otherwise: Yup.string().notRequired().matches(/^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/, 'Nomor NPWP tidak valid'),
        }),
});

export default addRefferalSchema;